/* global axios */
import ApiClient from './ApiClient';

class EmailMarketingTemplatesAPI extends ApiClient {
  constructor() {
    super('email_marketing_templates', { accountScoped: true });
  }

  archive(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new EmailMarketingTemplatesAPI();
